import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslationService } from './services/translation.service';
import { StyleManager } from './services/style-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(
    private translateService: TranslationService,
    private styleManager: StyleManager,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit(): void {
    this.document.body.classList.remove('mat-typography');
    this.setLnag();
    this.styleManager.toggleTheme();
  }

  setLnag() {
    const lang = this.translateService.getSelectedLanguage();
    this.translateService.setLanguage(lang)
  }
}
